import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './App.module.css';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { BenefitsSection } from './components/BenefitsSection';
import { StepsSection } from './components/StepsSection';
import { GrowthSection } from './components/GrowthSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import ProductSection from './components/ProductSection';
import { GiftSection } from './components/GiftSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { EmailCaptureModal } from './components/EmailCaptureModal';
import { DataDeletionModal } from './components/DataDeletionModal';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeletionModalOpen, setIsDeletionModalOpen] = useState(false);
  const hasPromptedRef = useRef(false);

  const openModal = useCallback(() => {
    hasPromptedRef.current = true;
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const openDeletionModal = useCallback(() => {
    setIsDeletionModalOpen(true);
  }, []);

  const closeDeletionModal = useCallback(() => {
    setIsDeletionModalOpen(false);
  }, []);

  useEffect(() => {
    if (hasPromptedRef.current) return;

    const promptOnce = () => {
      if (hasPromptedRef.current) return;
      hasPromptedRef.current = true;
      setIsModalOpen(true);
    };

    const timeoutId = window.setTimeout(promptOnce, 8000);

    const onScroll = () => {
      if (hasPromptedRef.current) return;
      const scrollTop = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (maxScroll > 0 && scrollTop / maxScroll >= 0.45) {
        promptOnce();
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.clearTimeout(timeoutId);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div className={styles.page}>
      <Header onPrimaryCtaClick={openModal} />
      <main>
        <Hero onPrimaryCtaClick={openModal} />
        <BenefitsSection />
        <StepsSection />
        <GrowthSection onPrimaryCtaClick={openModal} />
        <TestimonialsSection />
        <ProductSection onPrimaryCtaClick={openModal} />
        <GiftSection onPrimaryCtaClick={openModal} />
        <FinalCtaSection onPrimaryCtaClick={openModal} />
      </main>
      <Footer onDataDeletionClick={openDeletionModal} />
      <EmailCaptureModal isOpen={isModalOpen} onClose={closeModal} />
      <DataDeletionModal isOpen={isDeletionModalOpen} onClose={closeDeletionModal} />
    </div>
  );
}

export default App;
